import { render, staticRenderFns } from "./Choice.vue?vue&type=template&id=28a6e44c&scoped=true"
import script from "./Choice.vue?vue&type=script&lang=js"
export * from "./Choice.vue?vue&type=script&lang=js"
import style0 from "./Choice.vue?vue&type=style&index=0&id=28a6e44c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a6e44c",
  null
  
)

export default component.exports